import { defineStore } from "pinia"
import { ref } from "vue"
import { watch } from "vue"
import { Member, play, Site } from "@voomp/play-back"
import { useAuthStore } from "./auth.store"

export const useStateStore = defineStore('state', () => {

  const authStore = useAuthStore()

  const initial = {
    member: {} as Member,
    site: {} as Site,
    role: null,
    custom_links: [] as Record<string, unknown>[],
    settings: {} as Record<string, unknown>
  }
  
  const member = ref<Member>(initial.member)
  const site = ref<Site>(initial.site)
  const role = ref<string>(initial.role as string)
  const customLinks = ref(initial.custom_links)
  const settings = ref(initial.settings)
  const loading = ref(false)

  async function fetch() {
    try {
      const resp = await play.auth.state({})
      member.value = resp.member || initial.member
      site.value = resp.site || initial.site
      role.value = resp.role || resp.member_site?.role || initial.role
      customLinks.value = resp.custom_links || initial.custom_links
      settings.value = resp.settings || initial.settings
    } finally {
      loading.value = false
    }
  }

  function $reset() {
    member.value = initial.member
    site.value = initial.site
    role.value = initial.role
    customLinks.value = initial.custom_links
    settings.value = initial.settings
  }

  watch(() => authStore.authorization, () => {
    fetch()
  }, {
    immediate: true,
  })

  function getMember() {
    return member.value
  }

  function getSettings() {
    return settings.value
  }

  function getSetting(key: string, defaultValue: unknown = null) {
    return settings.value?.[key] ?? defaultValue
  }

  function patchSettings(patch: Record<string, unknown>) {
    settings.value = { ...settings.value, ...patch }
  }

  return {
    member,
    site,
    role,
    settings,
    fetch,
    $reset,
    customLinks,
    getSettings,
    getSetting,
    getMember,
    patchSettings,
  }
})
